import React from "react";
import {
  MainContainer,
  InnerMainContainer,
  ImageContainer,
  RightContainer,
  Heading,
  Description,
  Button,
  ButtonContainer,
} from "./styled.components";
import CEOIMAGE from "../../../../assets/images/edited.jpeg";
const CeoMessage = () => {
  return (
    <MainContainer>
      <InnerMainContainer>
        <ImageContainer src={CEOIMAGE} />
        <RightContainer>
          <Heading>Message From The CEO</Heading>
          <Description>
            As the CEO of 3H&Sons Constructors and Engineers, it is with
            profound gratification that I extend my salutations. As a
            pre-eminent infrastructure company, established over five decades
            ago, our enterprise has, over the years, strongly anchored itself to
            Pakistan's development effort. In stewarding this enterprise, I am
            honored to lead a cadre of professional engineers and staff united
            by a shared pursuit: the orchestration of urban evolution through
            superlative edifices and thoroughfares. Our odyssey is one
            characterized by project planning, design, execution, and management
            for residential, commercial, and infrastructure projects. With each
            project embarked upon, we envisage not merely brick and mortar, but
            rather the blueprint of thriving societies. Our methodology is
            predicated upon consummate professionalism, crystalline
            transparency, and an unswerving quest for distinction. Our endeavor
            extends beyond erecting physical forms; it embraces the creation of
            spaces that mirror our adroitness and wholehearted dedication. The
            cornerstone of our enterprise is our clientele. We take immense
            pride in surpassing anticipation, a commitment that renders every
            constructed edifice and thoroughfare an elemental substrate for
            advancement. I beseech you to traverse our digital domain, acquaint
            yourself with our offerings, and bear witness to our ardor for
            construction and infrastructure management. In contemplating us as
            your collaborators in transmuting dreams into tangible actuality, I
            extend my gratitude.
          </Description>
          <p style={{ color: "#373737", margin: "unset" }}>Cordially,</p>
          <p style={{ color: "#373737" }}>
            <strong>Shabbir Hussain</strong>
            <br></br>
            Founder &amp; , CEO 3H & SONS ENGINEERS AND CONTRATORS
          </p>
        </RightContainer>
      </InnerMainContainer>
    </MainContainer>
  );
};

export default CeoMessage;
